<template>
  <div>
    <SupportSectionCurrentProduct
      class="sections-lateral-spaces"
      :name="t('see_website_another_regions')"
      :breadcrumb-items="breadcrumbItems"
    />
    <div class="page-content sections-lateral-spaces pt-20">
      <ul>
        <li v-for="country in countriesAndRegions" :key="country.code">
          <nuxt-link :to="localePath(`/${country.code}/`)">
            {{ `${country.region} - ${country.language}` }}
          </nuxt-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
// Types

definePageMeta({
  layout: 'support',
  keepalive: true
});

// ---------------------------------------
// Hooks
// ---------------------------------------

const { t, locales } = useI18n();
const localePath = useLocalePath();

const breadcrumbItems = computed(() => [
  { title: t("support"), path: localePath("/") },
  { title: t("choose_your_country_lang") },
])

const countriesAndRegions = computed(() => {
  const translatedLocales = locales.value
    .map((locale) => ({
      region: t(`country_${locale.region2}`),
      code: locale.code,
      language: t(`locale_${locale.language}`),
    }))
    .sort((a, b) => a.region.localeCompare(b.region));

  return translatedLocales;
});



// ---------------------------------------
// Meta
// ---------------------------------------

useSeoMeta({
  title: t('choose_your_country_lang'),
  ogTitle: t('choose_your_country_lang'),
  robots: 'noindex',
});
</script>

<style lang="scss" scoped>
ul {
  gap: 16px;

  li {
    margin-bottom: 16px;
  }
}

@media (screen(md)) {
  ul {
    columns: 2;
  }
}

@media (screen(xl)) {
  ul {
    columns: 4;
  }
}
</style>
